import { c as _c } from "react/compiler-runtime";
import { Icon, Typography } from "../../atoms";
import { useTranslations } from "next-intl";
interface NoDataTemplatesProps {
  pageName: string;
  className?: string;
  priority?: boolean;
}
const NoDataTemplates = t0 => {
  const $ = _c(20);
  const {
    pageName,
    className,
    priority: t1
  } = t0;
  const priority = t1 === undefined ? false : t1;
  const t = useTranslations();
  let t2;
  if ($[0] !== pageName || $[1] !== t) {
    const getPageInfo = () => {
      switch (pageName) {
        case "favorite":
          {
            return {
              text: t("commonNoData.favorite"),
              icon: "/icons/no-favorite.svg",
              iconWidth: 100,
              iconHeight: 100
            };
          }
        case "review":
        case "reviewBg":
          {
            return {
              text: t("commonNoData.review"),
              icon: "/icons/no-review.svg",
              iconWidth: 100,
              iconHeight: 100
            };
          }
        case "inquiry":
          {
            return {
              text: t("commonNoData.inquiry"),
              icon: "/icons/no-inquiry.svg",
              iconWidth: 100,
              iconHeight: 100
            };
          }
        case "search":
          {
            return {
              text: t("commonNoData.search"),
              subText: t("commonNoData.searchSubText"),
              icon: "/icons/no-search.svg",
              iconWidth: 40,
              iconHeight: 40
            };
          }
        case "analysis":
          {
            return {
              text: t("commonNoData.analysis"),
              subText: t("commonNoData.analysisSubText"),
              icon: "/icons/no-analysis.svg",
              iconWidth: 100,
              iconHeight: 100
            };
          }
        case "treatmentCase":
          {
            return {
              text: t("commonNoData.treatmentCase"),
              icon: "/icons/document.svg",
              iconWidth: 100,
              iconHeight: 100
            };
          }
        case "hospitalInfo":
          {
            return {
              text: t("commonNoData.hospitalInfo"),
              icon: "/icons/document.svg",
              iconWidth: 100,
              iconHeight: 100
            };
          }
        default:
          {
            return {
              text: "",
              subText: "",
              icon: "",
              iconWidth: 0,
              iconHeight: 0
            };
          }
      }
    };
    t2 = getPageInfo();
    $[0] = pageName;
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    text,
    subText,
    icon,
    iconWidth,
    iconHeight
  } = t2;
  let t3;
  if ($[3] !== pageName) {
    t3 = () => {
      switch (pageName) {
        case "reviewBg":
        case "analysis":
        case "treatmentCase":
        case "hospitalInfo":
          {
            return "bg-white";
          }
        default:
          {
            return "bg-[#F7F7F7]";
          }
      }
    };
    $[3] = pageName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getBgColor = t3;
  const t4 = `flex flex-1 flex-col items-center justify-center ${getBgColor()} ${className}`;
  const t5 = `${pageName}-empty`;
  let t6;
  if ($[5] !== icon || $[6] !== iconHeight || $[7] !== iconWidth || $[8] !== priority || $[9] !== t5) {
    t6 = <Icon src={icon} alt={t5} width={iconWidth} height={iconHeight} priority={priority} />;
    $[5] = icon;
    $[6] = iconHeight;
    $[7] = iconWidth;
    $[8] = priority;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== text) {
    t7 = <Typography size={16} lineHeight={22} className="mt-[14px] text-[#5A5C63] font-medium">{text}</Typography>;
    $[11] = text;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== subText) {
    t8 = subText && <Typography size={14} lineHeight={22} className="mt-[4px] text-[#878A93] font-medium">{subText}</Typography>;
    $[13] = subText;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <div className={t4}>{t6}{t7}{t8}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default NoDataTemplates;